<!--
 * @Author: your name
 * @Date: 2020-12-21 09:52:12
 * @LastEditTime: 2020-12-30 15:14:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/ReportBugContent/index.vue
-->
<style scoped lang="sass">
$color: var(--menu-primary-text-colour)

.app_container
  height: 100%
  display: flex
  flex-direction: column
  align-items: center

.button
  width: 100%
  height: 56PX

.img_container
  height: 66PX
  width: 66PX
  margin-top: 8PX

.img
  height: 100%
  width: 100%

.title
  line-height: 1
  font-size: 17PX
  margin-top: 18PX
  margin-bottom: 26PX
  text-align: center
  color: $color

.info
  line-height: 17PX
  font-size: 14PX
  text-align: center
  color: $color

.report_content
  height: 162PX
  width: 100%
  margin-top: 24PX
  margin-bottom: 14PX

.form
  height: 100%

  >div
    height: 100%

::v-deep
  .van-button--primary
    background: var(--menu-primary-background-colour)
    border: none
    border-radius: 4PX !important

  .py_form_item_box
    height: 100%
</style>

<template lang="pug">
.app_container
  .img_container
    img.img(:src="reportBugSrc")
  .title.b {{ title }}
  .info.o75 {{ info }}
  .report_content
    py-form.form(
      ref="form"
      :model="valueFields"
      :rules="ruleValidate"
    )
      py-form-item(prop='comment')
        py-text-area.area(
          v-model="valueFields.comment"
          :auto-height="true"
          :background-color="backgroundColor"
          :maxlength="maxLength"
          :cancelOverFlowHidden="true"
          :placeholder="placeholder"
          :padding="paddingInfo"
          v-bind:style="{ height: '100%' }"
        )
  van-button.button.b.ls1(type="primary" @click="clickHandler") {{ buttonText }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    valueFields: {
      type: Object
    }
  }
})

class ReportBugContent extends Vue {
  paddingInfo = '10px !important'
  ruleValidate = {
    comment: [
      { required: true, message: 'Reporter content is required', trigger: 'blur' },
    ],
  }

  placeholder = 'Provide details here such as what happened just before you noticed the bug...'
  maxLength = '500'
  backgroundColor = '#f8f8f8'
  buttonText = 'SEND REPORT'
  title = 'Report a bug'
  info= 'Help us squash any nasty bugs you come across. Please provide as much detail as you can.'
  reportBugSrc = require('@/assets/report-bug/report-bug.png')

  clickHandler() {
    this.$refs.form.validate(res => {
      if (res) this.$emit('closeReportBugDialog')
    })
  }
}

export default ReportBugContent
</script>